import React from 'react';
import propTypes from 'prop-types';

export default function Buttons (props) {

  const { index, total, loop, prevHandler, nextHandler } = props;

  return (total!==0) && (
    <div className='Slider-Button-Wrapper'>
      { (loop || index !== 0) && (
        <div className='button left' onClick={prevHandler}>◀</div>
      )}
      { (loop || index !== total - 1) && (
        <div className='button right' onClick={nextHandler}>▶</div>
      )}
    </div>
  )
}

Buttons.propTypes = {
  index: propTypes.number.isRequired,
  total: propTypes.number.isRequired,
  prevHandler: propTypes.func,
  nextHandler: propTypes.func
}
